// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.D4xYZeafBT1BSiJxCtlL{padding-bottom:var(--spacing-xxxs)}.vIYkwDOBRS6EKNCI9Gqm{width:100%;gap:1px}`, "",{"version":3,"sources":["webpack://./src/components/navigation/navigation-panel/sub-navigation-panel/ui-components/navigation-sub-section/navigation-sub-section.scss"],"names":[],"mappings":"AAAA,sBACI,kCAAA,CAGJ,sBACI,UAAA,CACA,OAAA","sourcesContent":[".container {\n    padding-bottom: var(--spacing-xxxs);\n}\n\n.menuItemsContainer {\n    width: 100%;\n    gap: 1px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `D4xYZeafBT1BSiJxCtlL`,
	"menuItemsContainer": `vIYkwDOBRS6EKNCI9Gqm`
};
export default ___CSS_LOADER_EXPORT___;
